import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { fade } from 'material-ui/utils/colorManipulator';
export function wrapState(ComposedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(SelectableList, _React$Component);

    var _super = _createSuper(SelectableList);

    function SelectableList() {
      var _this;

      _classCallCheck(this, SelectableList);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "handleRequestChange", function (event, index) {
        _this.setState({
          selectedIndex: _this.props.multiple ? [].concat(_toConsumableArray(_this.state.selectedIndex), [index]).filter(function (a) {
            return a;
          }) : index
        }, function () {
          if (_this.props.onChange) {
            _this.props.onChange(_this.state.selectedIndex);
          }
        });
      });

      _defineProperty(_assertThisInitialized(_this), "handleDeselectItem", function (event, index) {
        if (_this.props.multiple) {
          var a = _toConsumableArray(_this.state.selectedIndex);

          a.splice(a.indexOf(index), 1);

          _this.setState({
            selectedIndex: a.filter(function (a) {
              return a;
            })
          }, function () {
            if (_this.props.onChange) {
              _this.props.onChange(_this.state.selectedIndex);
            }
          });
        }
      });

      return _this;
    }

    _createClass(SelectableList, [{
      key: "UNSAFE_componentWillMount",
      value: function UNSAFE_componentWillMount() {
        var _this2 = this;

        this.setState({
          selectedIndex: this.props.defaultValue ? this.props.defaultValue : this.props.multiple ? [] : null
        }, function () {
          if (_this2.props.onChange) {
            _this2.props.onChange(_this2.state.selectedIndex);
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            rest = _objectWithoutProperties(_this$props, ["children"]);

        return /*#__PURE__*/React.createElement(ComposedComponent, _extends({}, rest, {
          value: this.state.selectedIndex,
          onChange: this.handleRequestChange,
          onDeselect: this.handleDeselectItem
        }), this.props.children);
      }
    }]);

    return SelectableList;
  }(React.Component);
}
export var makeSelectable = function makeSelectable(MyComponent) {
  var _class2, _temp;

  return _temp = _class2 = /*#__PURE__*/function (_Component) {
    _inherits(_class2, _Component);

    var _super2 = _createSuper(_class2);

    function _class2() {
      var _this3;

      _classCallCheck(this, _class2);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this3 = _super2.call.apply(_super2, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this3), "hasSelectedDescendant", function (previousValue, child) {
        if ( /*#__PURE__*/React.isValidElement(child) && child.props.nestedItems && child.props.nestedItems.length > 0) {
          return child.props.nestedItems.reduce(_this3.hasSelectedDescendant, previousValue);
        }

        return previousValue || _this3.isChildSelected(child, _this3.props);
      });

      _defineProperty(_assertThisInitialized(_this3), "handleItemTouchTap", function (event, item) {
        var itemValue = item.props.value;

        if (!(_this3.props.value instanceof Array) && itemValue !== _this3.props.value) {
          if (_this3.props.onChange) {
            _this3.props.onChange(event, itemValue);
          }
        } else if (_this3.props.value instanceof Array) {
          if (_this3.props.value.includes(itemValue)) {
            if (_this3.props.onDeselect) {
              _this3.props.onDeselect(event, itemValue);
            }
          } else {
            _this3.props.onChange(event, itemValue);
          }
        }
      });

      return _this3;
    }

    _createClass(_class2, [{
      key: "extendChild",
      value: function extendChild(child, styles, selectedItemStyle) {
        var _this4 = this;

        if (child && child.type && child.type.muiName === 'ListItem') {
          var selected = this.isChildSelected(child, this.props);
          var selectedChildrenStyles;

          if (selected) {
            selectedChildrenStyles = Object.assign({}, styles, selectedItemStyle);
          }

          var mergedChildrenStyles = Object.assign({}, child.props.style, selectedChildrenStyles);
          this.keyIndex += 1;
          return /*#__PURE__*/React.cloneElement(child, {
            onClick: function onClick(event) {
              _this4.handleItemTouchTap(event, child);

              if (child.props.onClick) {
                child.props.onClick(event);
              }
            },
            key: this.keyIndex,
            style: mergedChildrenStyles,
            nestedItems: child.props.nestedItems.map(function (child) {
              return _this4.extendChild(child, styles, selectedItemStyle);
            }),
            initiallyOpen: this.isInitiallyOpen(child)
          });
        }

        return child;
      }
    }, {
      key: "isInitiallyOpen",
      value: function isInitiallyOpen(child) {
        if (child.props.initiallyOpen) {
          return child.props.initiallyOpen;
        }

        return this.hasSelectedDescendant(false, child);
      }
    }, {
      key: "isChildSelected",
      value: function isChildSelected(child, props) {
        return props.value instanceof Array ? props.value.includes(child.props.value) : props.value === child.props.value;
      }
    }, {
      key: "render",
      value: function render() {
        var _this5 = this;

        var _this$props2 = this.props,
            children = _this$props2.children,
            selectedItemStyle = _this$props2.selectedItemStyle,
            other = _objectWithoutProperties(_this$props2, ["children", "selectedItemStyle"]);

        this.keyIndex = 0;
        var styles = {};

        if (!selectedItemStyle) {
          var textColor = this.context.muiTheme.baseTheme.palette.textColor;
          styles.backgroundColor = fade(textColor, 0.2);
        }

        return /*#__PURE__*/React.createElement(MyComponent, _extends({}, other, this.state), Children.map(children, function (child) {
          return _this5.extendChild(child, styles, selectedItemStyle);
        }));
      }
    }]);

    return _class2;
  }(Component), _defineProperty(_class2, "propTypes", {
    children: PropTypes.node,
    onChange: PropTypes.func,
    selectedItemStyle: PropTypes.object,
    value: PropTypes.any
  }), _defineProperty(_class2, "contextTypes", {
    muiTheme: PropTypes.object.isRequired
  }), _temp;
};
export default makeSelectable;